import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Block } from '../phonenumber.model';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from 'src/app/app.model';
import { PhonenumberService } from '../phonenumber.service';
import { I18NextService } from 'angular-i18next';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cancel-number-confirmation',
  templateUrl: './cancel-number-confirmation.component.html',
  standalone: false
})
export class CancelNumberConfirmationComponent extends AutorunComponent implements OnInit {

  @Input() block: Block;
  @Input() cancellationDate: string;

  @Output() public back = new EventEmitter<number>();
  @Output() public confirmed = new EventEmitter<string>();

  public blockText = '<br>';
  public checked = false;

  constructor(private m: Model,
    private phoneNumberService: PhonenumberService,
    private i18next: I18NextService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
    const block = this.block;
    if (block.numbers.length > 1) {
      this.blockText += `${this.i18next.t('type') as string}: ${this.i18next.t('phonenumber_type_block') as string}<br>
                    ${this.i18next.t('start') as string}: ${block.fromNumber}<br>
                    ${this.i18next.t('end') as string}: ${block.toNumber}<br>
                    ${this.i18next.t('length') as string}: ${block.numbers.length}`;
    } else {
      this.blockText += `${this.i18next.t('type') as string}: ${this.i18next.t('phonenumber_type_single') as string}<br>
                    ${this.i18next.t('phonenumber') as string}: ${block.fromNumber}`;
    }
  }

  onBack() {
    this.back.emit();
  }

  onConfirm() {
    this.confirmed.emit('confirmed');
  }

  doCheck(checked: boolean) {
    this.checked = checked;
  }
}
